import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { isInitialMeLoad, useMe } from '@/api/domains/merchant-settings';

/**
 * Redirects merchants who still need the first-time setup wizard to `/setup`.
 * Wraps the main app layout (not `/setup` itself, so there is no redirect loop).
 * Stays out of the way while `me` loads or on error - it only acts on a
 * definitive `onboarding.required` flag from the backend.
 */
export function OnboardingGate({ children }: { children: ReactNode }) {
  const meQuery = useMe();

  if (isInitialMeLoad(meQuery)) {
    return (
      <div className="flex h-full items-center justify-center text-muted-foreground">Loading…</div>
    );
  }

  if (meQuery.data?.onboarding.required) {
    return <Navigate to="/setup" replace />;
  }

  return children;
}
